import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AdminSessionAuthLevelGuard } from '../common/guards/admin-session-auth-level/admin-session-auth-level.guard';
import { AuthGuard } from '../common/guards/auth/auth.guard';
import { DoctorRoleGuard, PatientRoleGuard } from '../common/guards/role-level-guard/role-level.guard';
import { SecondAuthLevelGuard } from '../common/guards/second-auth-level/second-auth-level.guard';
import { UserNotLoggedGuard } from '../common/guards/user-logged/user-logged.guard';
import { SessionTokenInterceptor } from '../common/interceptors/session-token/session-token.interceptor';
import { StaticModule } from '../components/static/static.module';
import { ConnectionRequestService } from '../components/user-relation-requests/services/connection-request.service';
import { FormsConstructorModule } from '../forms/forms-constructor.module';
import { SharedModule } from '../shared.module';
import { ViewsModule } from '../views/views.module';
import { AcceptAdminSignupInvitationComponent } from './accept-signup-invitation/accept-admin-signup-invitation/accept-admin-signup-invitation.component';
import { AuthService } from './auth.service';
import { BindAuthenticatorComponent } from './bind-authenticator/bind-authenticator.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { LoginComponent } from './login/login.component';
import { RecoveryPasswordComponent } from './recovery-password/recovery-password.component';
import { RegistrationComponent } from './registration/registration.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SecondAuthLevelService } from './second-auth-level.service';
import { SecondAuthLevelComponent } from './second-auth-level/second-auth-level.component';
import { SessionService } from './session.service';

@NgModule({
  imports: [SharedModule, FormsConstructorModule, ViewsModule, StaticModule],
  declarations: [
    LoginComponent,
    RegistrationComponent,
    AcceptAdminSignupInvitationComponent,
    SecondAuthLevelComponent,
    BindAuthenticatorComponent,
    ResetPasswordComponent,
    RecoveryPasswordComponent,
    ChangePasswordComponent,
  ],
  exports: [
    LoginComponent,
    RegistrationComponent,
    AcceptAdminSignupInvitationComponent,
    SecondAuthLevelComponent,
    ChangePasswordComponent,
    ResetPasswordComponent,
    RecoveryPasswordComponent,
  ],
})
export class AuthModule {
  public static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        AuthService,
        SecondAuthLevelService,
        SessionService,
        ConnectionRequestService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: SessionTokenInterceptor,
          multi: true,
        },
        AuthGuard,
        SecondAuthLevelGuard,
        AdminSessionAuthLevelGuard,
        DoctorRoleGuard,
        PatientRoleGuard,
        UserNotLoggedGuard,
      ],
    };
  }
}
